import { useMemo } from 'react';
import { useBrandKitRepository } from './brand-kit-repository';

export const useBrandKitService = () => {
  const dataService = useBrandKitRepository();
  const {
    getBrandKits,
    updateBrandKit,
    createBrandKits,
    brandkitResp,
    brandkitError,
    cache,
    brandkitLoading,
  } = dataService;

  const brandKitDataService = useMemo(() => ({
    getBrandKits,
    updateBrandKit,
    createBrandKits,
  }), [createBrandKits, getBrandKits, updateBrandKit]);

  const brandkitApiState = useMemo(() => ({
    brandkitResp,
    brandkitError,
    cache,
    brandkitLoading,
  }), [brandkitError, brandkitLoading, brandkitResp, cache]);

  return {
    brandKitDataService,
    brandkitApiState,
  };
};
